import { Component } from '@angular/core';

@Component({
  selector: 'app-therapeutic-doses',
  templateUrl: './therapeutic-doses.component.html',
  styleUrls: ['./therapeutic-doses.component.scss']
})
export class TherapeuticDosesComponent {
  public locale: string = $localize.locale;
}
